var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureThumbsdownOn = function SvgGeneralFeatureThumbsdownOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M10.867 20.275a2.26 2.26 0 0 0 2.26 2.225l.218-.01a2.264 2.264 0 0 0 2.046-2.254l.006-.683c.03-1.413.2-2.402 1.054-3.256.516-.516.854-.876 1.145-1.223l.335-.418.34-.458.625-.88h2.887V4.286a2.264 2.264 0 0 0-2.263-2.264h-.637v.07-.07l-2.018-.188-1.867-.134-1.488-.084-.802-.036-1.264-.045-.876-.02a2 2 0 0 0-.221-.015H5.77c-.939 0-1.707.768-1.707 1.708a1.7 1.7 0 0 0 .816 1.451A1.713 1.713 0 0 0 3.31 6.361c0 .614.328 1.155.819 1.452a1.704 1.704 0 0 0-.758 3.154c-.876.07-1.57.81-1.57 1.702 0 .94.768 1.707 1.707 1.707h5.09a2.265 2.265 0 0 1 2.265 2.265z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureThumbsdownOn;